import { render, staticRenderFns } from "./chongzhi.vue?vue&type=template&id=b189aafc&scoped=true&"
import script from "./chongzhi.vue?vue&type=script&lang=js&"
export * from "./chongzhi.vue?vue&type=script&lang=js&"
import style0 from "./chongzhi.scss?vue&type=style&index=0&id=b189aafc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b189aafc",
  null
  
)

export default component.exports